import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import text from './text';
import { Switch } from '@material-ui/core';

const language = window.location.hash === '#en' ? 'eng' : 'hun';

const ALCOHOL_1 = 2;
const ALCOHOL_2 = 4;
const ALCOHOL_3 = 8;
const ALCOHOL_4 = 16;
const ALCOHOL_5 = 32;

const ALCOHOLS = [ALCOHOL_1, ALCOHOL_2, ALCOHOL_3, ALCOHOL_4, ALCOHOL_5];

const alcohol = 30;
const noalcohol = 62;
export default ({filter, onChange}) => {
  return (
    <div className="filterByAlcohol option">
        <FormControl component="fieldset">
          <FormLabel component="legend">{text[language].filtersGroupNames.alcoholFilterTitle}</FormLabel>
          <Switch
            checked={(filter < noalcohol) && true}
            onClick={() => onChange(filter = (filter === noalcohol) ? alcohol : noalcohol)}
            color="primary"
          />
        </FormControl>
      </div>
  );
}